module.exports = __webpack_public_path__ + "static/img/prize1.692e8c6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/prize1.png
// module id = TkKB
// module chunks = 1